export interface ClientTraceContext {
  traceId: string;
  spanId: string;
  traceparent: string;
  requestId: string;
}

let lastTraceparent: string | null = null;
let lastRequestId: string | null = null;

function randomHex(bytes: number): string {
  const array = new Uint8Array(bytes);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function createClientTraceContext(): ClientTraceContext {
  const traceId = randomHex(16);
  const spanId = randomHex(8);
  const requestId = crypto.randomUUID();
  return {
    traceId,
    spanId,
    requestId,
    traceparent: `00-${traceId}-${spanId}-01`,
  };
}

export function rememberResponseTrace(traceparent: string | null, requestId: string | null): void {
  if (traceparent) lastTraceparent = traceparent;
  if (requestId) lastRequestId = requestId;
}

export function getLastTraceparent(): string | null {
  return lastTraceparent;
}

export function getLastRequestId(): string | null {
  return lastRequestId;
}
